import type {
  ArchiveItem,
  FaqItem,
  HomeTopic,
  NavItem,
  ResourceType,
  TrustMetric,
  VerifyStep,
} from '@/pages/home/types';

export const homeNavItems: NavItem[] = [
  { id: 'nav-topics', label: '话题墙', href: '#topics' },
  { id: 'nav-archive', label: '素材归档', href: '#archive' },
  { id: 'nav-types', label: '素材形态', href: '#types' },
  { id: 'nav-verify', label: '核验说明', href: '#verify' },
  { id: 'nav-faq', label: '常见问题', href: '#faq' },
];

export const homeTopics: HomeTopic[] = [
  { id: 'all', name: '全部素材', count: 128 },
  { id: 'live', name: '直播录屏', count: 42 },
  { id: 'raw', name: '未删减原视频', count: 26 },
  { id: 'chat', name: '聊天记录截图', count: 31 },
  { id: 'scene', name: '现场原始截图', count: 19 },
  { id: 'timeline', name: '时间线整理', count: 12 },
  { id: 'reverse', name: '反转合集', count: 9 },
  { id: 'official', name: '官方通报', count: 7 },
  { id: 'clarify', name: '澄清声明', count: 6 },
  { id: 'source', name: '出处核查', count: 14 },
  { id: 'submit', name: '网友投稿', count: 22 },
  { id: 'verified', name: '已核验实锤', count: 18 },
];

export const homeTrustMetrics: TrustMetric[] = [
  { id: 'trust-total', value: '128', label: '归档素材条目', note: '按素材形态与话题分组整理' },
  { id: 'trust-video', value: '68', label: '原视频 / 录屏留存', note: '保留原始时间轴与画幅信息' },
  { id: 'trust-shot', value: '50', label: '原始截图存档', note: '含出处标注与拍摄时间说明' },
  { id: 'trust-verified', value: '18', label: '已核验实锤', note: '完成出处比对与时间线复核' },
];

export const homeArchiveItems: ArchiveItem[] = [
  {
    id: 'a-0731',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20cover%20for%20a%20video%20clip%20archive%20card%2C%20layered%20translucent%20timeline%20strips%20over%20a%20warm%20cream%20paper%20background%20with%20burnt%20orange%20gradient%20light%2C%20soft%20film%20grain%2C%20minimal%20geometric%20shapes%2C%20no%20people%2C%20high%20detail%20studio%20composition&width=800&height=600&seq=nh-cover-0731&orientation=landscape',
    topicId: 'live',
    category: '直播录屏',
    title: '直播间争议片段 · 完整无剪辑录屏归档',
    summary: '保留原始时间轴与弹幕轨迹，可与二次剪辑版本逐帧比对，确认是否有删改。',
    labels: ['录屏', '完整版', '已核验'],
    meta: '归档于 2026-08-14 · 编号 A-0731',
    duration: '12:36',
  },
  {
    id: 'a-0712',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20cover%20showing%20stacked%20raw%20video%20frame%20panels%20on%20a%20muted%20terracotta%20and%20cream%20background%2C%20amber%20rim%20light%2C%20blurred%20motion%20strips%2C%20minimal%20flat%20composition%2C%20no%20people%2C%20soft%20shadows%2C%20high%20detail%20magazine%20aesthetic&width=800&height=600&seq=nh-cover-0712&orientation=landscape',
    topicId: 'raw',
    category: '未删减原视频',
    title: '未删减原视频 · 时长与帧率信息完整留存',
    summary: '保留原始编码信息与文件时长，方便核对是否存在加速、裁切或音画不同步。',
    labels: ['原视频', '未删减', '待复核'],
    meta: '归档于 2026-08-09 · 编号 A-0712',
    duration: '07:48',
  },
  {
    id: 'a-0698',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20cover%20with%20overlapping%20screenshot%20panes%20and%20chat%20bubble%20outlines%20on%20a%20warm%20sand%20textured%20background%2C%20golden%20amber%20accent%20light%2C%20minimal%20grid%20layout%2C%20no%20people%2C%20clean%20studio%20photography%20feel%2C%20high%20detail&width=800&height=600&seq=nh-cover-0698&orientation=landscape',
    topicId: 'chat',
    category: '聊天记录截图',
    title: '聊天记录截图串 · 头像与时间戳拼接对照',
    summary: '按时间顺序拼接截图，标注截取位置与设备信息，提示可能存在的裁剪风险。',
    labels: ['截图', '时间戳', '出处待补'],
    meta: '归档于 2026-08-05 · 编号 A-0698',
    duration: '18 张',
  },
  {
    id: 'a-0654',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20cover%20with%20a%20single%20framed%20still%20image%20placeholder%20and%20label%20tag%20shapes%2C%20deep%20burnt%20orange%20against%20soft%20cream%20background%2C%20warm%20side%20lighting%2C%20minimal%20negative%20space%2C%20no%20people%2C%20high%20detail%20editorial%20style&width=800&height=600&seq=nh-cover-0654&orientation=landscape',
    topicId: 'scene',
    category: '现场原始截图',
    title: '现场原始截图 · EXIF 与拍摄时间标注',
    summary: '附原始文件与拍摄时间说明，供比对是否为同一场景、是否存在后期合成痕迹。',
    labels: ['原始截图', 'EXIF', '已核验', '网友投稿'],
    meta: '归档于 2026-07-30 · 编号 A-0654',
    duration: '9 张',
  },
  {
    id: 'a-0621',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20cover%20illustrating%20a%20clean%20vertical%20timeline%20with%20marker%20dots%20on%20a%20warm%20cream%20background%2C%20amber%20and%20terracotta%20accent%20nodes%2C%20minimal%20infographic%20composition%2C%20no%20people%2C%20soft%20grain%20texture%2C%20high%20detail&width=800&height=600&seq=nh-cover-0621&orientation=landscape',
    topicId: 'timeline',
    category: '时间线整理',
    title: '事件时间线整理 · 逐条标注素材出处',
    summary: '把零散素材按发生顺序串联，每条结论都挂回可查证的原始条目编号。',
    labels: ['时间线', '出处标注', '更新中'],
    meta: '归档于 2026-07-24 · 编号 A-0621',
    duration: '23 节点',
  },
  {
    id: 'a-0587',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20cover%20with%20two%20contrasting%20panels%20split%20diagonally%2C%20warm%20golden%20and%20deep%20clay%20tones%20on%20a%20cream%20paper%20background%2C%20minimal%20geometric%20contrast%2C%20no%20people%2C%20soft%20studio%20lighting%2C%20high%20detail%20magazine%20aesthetic&width=800&height=600&seq=nh-cover-0587&orientation=landscape',
    topicId: 'reverse',
    category: '反转合集',
    title: '反转素材合集 · 前后版本差异对照',
    summary: '同一事件的前后说法并列展示，标注新增证据与已失效素材，避免只看到单边版本。',
    labels: ['反转', '对照', '已核验', '网友投稿'],
    meta: '归档于 2026-07-18 · 编号 A-0587',
    duration: '6 组',
  },
  {
    id: 'a-0543',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20cover%20showing%20an%20official%20notice%20document%20silhouette%20with%20a%20seal%20shape%2C%20muted%20olive%20and%20cream%20palette%20with%20warm%20amber%20highlight%2C%20minimal%20flat%20composition%2C%20no%20people%2C%20clean%20studio%20photography%2C%20high%20detail&width=800&height=600&seq=nh-cover-0543&orientation=landscape',
    topicId: 'official',
    category: '官方通报',
    title: '相关方通报原文 · 链接与发布时间留存',
    summary: '只收录可回溯来源的公开通报，标注发布主体与时间，作为核验基准。',
    labels: ['官方通报', '原文留存', '权威来源'],
    meta: '归档于 2026-07-11 · 编号 A-0543',
    duration: '5 份',
  },
  {
    id: 'a-0512',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20cover%20with%20a%20speech%20bubble%20outline%20and%20stamp%20mark%20shapes%2C%20soft%20cream%20and%20light%20clay%20tones%20with%20warm%20accent%20light%2C%20minimal%20graphic%20composition%2C%20no%20people%2C%20soft%20shadows%2C%20high%20detail&width=800&height=600&seq=nh-cover-0512&orientation=landscape',
    topicId: 'clarify',
    category: '澄清声明',
    title: '当事方澄清声明 · 与既有素材并列展示',
    summary: '把澄清内容与对应素材放在一起对照，标注尚未被回应的争议点。',
    labels: ['澄清', '并列展示', '待回应'],
    meta: '归档于 2026-07-06 · 编号 A-0512',
    duration: '4 份',
  },
  {
    id: 'a-0488',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20cover%20showing%20magnifier%20and%20source%20tag%20shapes%20over%20layered%20paper%20sheets%2C%20warm%20cream%20and%20amber%20palette%2C%20minimal%20verification%20theme%2C%20no%20people%2C%20clean%20studio%20lighting%2C%20high%20detail&width=800&height=600&seq=nh-cover-0488&orientation=landscape',
    topicId: 'source',
    category: '出处核查',
    title: '素材出处核查 · 首发时间与传播路径',
    summary: '追溯素材最早出现的位置与转发路径，标注无法确认源头的条目。',
    labels: ['出处', '溯源', '已核验'],
    meta: '归档于 2026-06-28 · 编号 A-0488',
    duration: '11 条',
  },
];

export const homeResourceTypes: ResourceType[] = [
  {
    id: 'type-video',
    icon: 'ri-film-line',
    name: '原视频',
    desc: '未经二次剪辑的完整文件，保留原始时长、分辨率与音轨信息，用于判断是否被加速或裁切。',
    points: ['原始时长留存', '编码信息标注', '音画同步核对'],
  },
  {
    id: 'type-screen',
    icon: 'ri-record-circle-line',
    name: '录屏',
    desc: '对直播或页面操作过程的连续录制，保留时间轴与操作轨迹，便于还原当时真实画面。',
    points: ['连续时间轴', '含操作轨迹', '可逐帧比对'],
  },
  {
    id: 'type-shot',
    icon: 'ri-image-2-line',
    name: '原始截图',
    desc: '未经过度压缩的原始图片，附带拍摄时间与出处说明，避免二次转发带来的信息损耗。',
    points: ['EXIF 信息', '出处标注', '压缩痕迹检查'],
  },
];

export const homeVerifySteps: VerifyStep[] = [
  {
    id: 'step-1',
    index: '01',
    title: '素材收集',
    desc: '按话题汇集原视频、录屏与原始截图，统一编号并登记来源，避免遗漏关键版本。',
  },
  {
    id: 'step-2',
    index: '02',
    title: '时间轴比对',
    desc: '将不同版本按时间轴对齐，核对时长、帧位置与音画同步，找出被删改的段落。',
  },
  {
    id: 'step-3',
    index: '03',
    title: '出处核验',
    desc: '回溯素材最早出现的位置与传播路径，无法确认源头的条目会明确标注为待核验。',
  },
  {
    id: 'step-4',
    index: '04',
    title: '标注结论',
    desc: '为每条素材打上核验状态标签，并同步收录相关方通报与澄清，保持信息完整。',
  },
];

export const homeFaqItems: FaqItem[] = [
  {
    id: 'faq-1',
    question: '什么叫「网红黑料实锤」和「网红黑料石锤」？',
    answer:
      '它们都指可被反复核对的硬证据，而不是聊天截图或单方面说法。判断标准是：素材可回溯到原始出处、有完整时间轴、并且能与其它独立来源相互印证。仅凭一张无出处的图片，我们不当作实锤。',
  },
  {
    id: 'faq-2',
    question: '为什么强调「网红黑料原视频」和「录屏」？',
    answer:
      '因为原视频和录屏保留完整的连续画面与时间信息，二次剪辑很容易删掉关键上下文。有了原素材，才能判断某句话是否被断章取义，或某个画面是否属于同一场景。',
  },
  {
    id: 'faq-3',
    question: '「网红黑料原始截图」和普通截图有什么区别？',
    answer:
      '原始截图指未经过多轮转发压缩、且保留了拍摄时间与来源说明的图片。多轮转发会造成画质损耗甚至被修改，原始截图更接近现场情况，也更容易被技术手段检验。',
  },
  {
    id: 'faq-4',
    question: '归档里的素材如何标注核验状态？',
    answer:
      '每条素材都会带上「已核验」「待复核」「出处待补」等状态标签。已核验代表完成了出处回溯与时间线比对；待复核代表素材已收录但仍有存疑点，需要配合其它来源再确认。',
  },
  {
    id: 'faq-5',
    question: '站内的内容可以随意转发吗？',
    answer:
      '不建议脱离上下文转发。单独截取某一段素材很容易造成误读，也会给当事方带来不必要的困扰。如确需引用，请同时附上出处与核验状态说明。',
  },
  {
    id: 'faq-6',
    question: '如果素材不实或涉及个人隐私怎么办？',
    answer:
      '我们以公开可回溯的通报与澄清作为核对基准，对被证实不实的条目会更新状态或移出归档。若涉及个人信息或权益争议，可通过页面底部的联系方式提交说明，我们会优先处理。',
  },
];